import { render, staticRenderFns } from "./AiHelpMeWriteDropdown.vue?vue&type=template&id=21042662&scoped=true"
import script from "./AiHelpMeWriteDropdown.vue?vue&type=script&lang=js"
export * from "./AiHelpMeWriteDropdown.vue?vue&type=script&lang=js"
import style0 from "./AiHelpMeWriteDropdown.vue?vue&type=style&index=0&id=21042662&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21042662",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21042662')) {
      api.createRecord('21042662', component.options)
    } else {
      api.reload('21042662', component.options)
    }
    module.hot.accept("./AiHelpMeWriteDropdown.vue?vue&type=template&id=21042662&scoped=true", function () {
      api.rerender('21042662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/StoryMode/Components/AiBuddy/AiHelpMeWriteDropdown.vue"
export default component.exports